import { FAIcon, Tooltip } from '@/components'
import { cn } from '@/lib/utils'
import { useTranslate } from '@ur-solutions/react-hooks'
import type { ExportStatus } from '../types'

function UserExportProgressInner({
  status: { status, message },
}: UserExportProgressProps) {
  const translations = useTranslate({
    pending: 'exports.status.pending',
    error: 'exports.status.error',
    success: 'exports.status.success',
  })

  return (
    <div
      className={cn(
        'relative px-4 pt-3 pb-[calc(0.75rem-1px)] rounded-full text-white select-none',
        status === 'pending'
          ? 'bg-[#5959e9]'
          : status === 'error'
          ? 'bg-[#bc0202]'
          : 'bg-[#0b970b]'
      )}
    >
      <FAIcon
        className="text-white mr-2"
        icon={
          status === 'pending'
            ? 'sync'
            : status === 'error'
            ? 'exclamation-circle'
            : 'check-circle'
        }
        type="solid"
        fixedWidth
      />

      <span>{translations[status]}</span>

      {status === 'pending' && (
        <span className="font-bold">&nbsp;{message}%</span>
      )}
    </div>
  )
}

interface UserExportProgressProps {
  status: ExportStatus
}

export function UserExportProgress({ status }: UserExportProgressProps) {
  if (status.status === 'error')
    return (
      <Tooltip content={status.message} asChild={false}>
        <UserExportProgressInner status={status} />
      </Tooltip>
    )

  return <UserExportProgressInner status={status} />
}
